// extracted by mini-css-extract-plugin
module.exports = {"form":"SponsorshipEmail_form___yGRU","action":"SponsorshipEmail_action__P1hi7"};